export default __webpack_public_path__ + "static/media/img-virtual-building-1.b624ee2d.png";